import { ConditionDefinition, FeatureDefinition } from 'core/funnel/store/selectors';
import { ContentOffer } from './ContentOffer';
import { LegacyOffersAttributes } from './LegacyOffersAttributes';

enum OffersConfigType {
  LEGACY = 'LEGACY',
  NATIVE = 'NATIVE',
  MIXED = 'MIXED',
}

export const offerGroups = [
  'defaultOffers',
  'timeUpOffers',
  'discountOffers',
  'upsells',
  'discountUpsells',
] as const;

export const offersAttributeMetaKeys: Array<string> = ['condition', 'feature'];

export type OfferGroup = (typeof offerGroups)[number];

export type OffersGroupsByName = Record<OfferGroup, Record<string, string>>;

export type OffersAttributes = OffersGroupsByName &
  Partial<{
    condition: ConditionDefinition;
    feature: FeatureDefinition;
  }>;

export type AnyOffersAttributes = OffersAttributes | LegacyOffersAttributes;

export type AnyOffersConfig = {
  attributes: Array<AnyOffersAttributes>;
  content?: ContentOffer;
};

export const isLegacyOffersAttributes = (
  attributes: AnyOffersAttributes,
): attributes is LegacyOffersAttributes => {
  return !('upsells' in attributes);
};

export const getOffersConfigType = (attributes: Array<AnyOffersAttributes>): OffersConfigType => {
  const legacyCount = attributes.filter(isLegacyOffersAttributes).length;

  if (!legacyCount) {
    return OffersConfigType.NATIVE;
  }

  if (legacyCount === attributes.length) {
    return OffersConfigType.LEGACY;
  }

  return OffersConfigType.MIXED;
};
